import { IDeleteRateioGeralUseCase } from "../../../presentation/useCases/delete/delete_rateio_geral_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * DeleteRateioGeralUseCase
 */

export class DeleteRateioGeralUseCase implements IDeleteRateioGeralUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async deleteRateioGeral(idContasPagar: number): Promise<void> {
    await this.repository.deleteRateioGeralById(idContasPagar);
  }
}
